import { Injectable, EventEmitter } from '@angular/core';
import * as _ from 'underscore';

export interface IToolbarAction {
  formId?: any;
  nestedFormId?: any;
  label?: string;
  tooltip?: string;
  icon?: any;
  command?: any;
  type: ToolbarActionType;
  identifier: any;
  disabled?: boolean | Function;
  sortOrder?: number;
  hidden?: any;
  dropdownGroup?: any;
  buttonType?: any;
  includeDivider?: boolean;
}

export enum ToolbarActionType {
  Button,
  IconButton
}


@Injectable({
  providedIn: 'root'
})
export class ToolbarActionsService {
  public selectedFormIdChange = new EventEmitter();
  public selectedNestedFormIdChange = new EventEmitter();
  private _selectedFormId: any = 0;
  private _selectedNestedFormId: any = 0;
  private _route: any = 0;
  public set route(value) {
    if (value != this._route) {
      this.items = new Array();
      this._route = value;

      this.setVisibleActions();
    }
  }


  public set selectedFormId(value) {
    this._selectedFormId = value;
    this.setVisibleActions();
    this.selectedFormIdChange.emit();
  }
  public set selectedNestedFormId(value) {
    this._selectedNestedFormId = value;
    this.setVisibleActions();
    this.selectedNestedFormIdChange.emit();
  }
  public get selectedFormId() {
    return this._selectedFormId;
  }
  public get selectedNestedFormId() {
    return this._selectedNestedFormId;
  }
  public get route() {
    return this._route;
  }
  public items: Array<IToolbarAction> = new Array<IToolbarAction>();
  public currentItems: Array<IToolbarAction> = new Array<IToolbarAction>();
  public currentDropdownGroups: any;
  constructor() {
    //this.items.push({ formId: 1, nestedFormId: 1, command: function () { }, icon: "save", label: 'test', type: ActionType.IconButton });
    //this.selectedFormId = 1;
    //this.selectedNestedFormId = 1;
  }
  public addItem(item: IToolbarAction) {
    this.items.push(item);
    this.setVisibleActions();
  }
  public removeItemByIndex(formId, nestedFormIndex) {
    var toRemove = this.items.filter(o => o.formId == formId && o.nestedFormId == nestedFormIndex);
    toRemove.forEach(o => {
      this.items.splice(this.items.indexOf(o), 1);
    })
    this.setVisibleActions();
  }
  public removeItem(item: IToolbarAction) {
    this.items.splice(this.items.indexOf(item), 1);
    this.setVisibleActions();
  }
  public setVisibleActions() {
    var items  = this.items.sort(function (a, b) { return a.sortOrder < b.sortOrder ? -1 : 1; }).filter(o => {
      return (typeof o.nestedFormId == "undefined" || o.nestedFormId == this._selectedNestedFormId) && o.formId == this._selectedFormId
    });
    //this.currentDropdownGroups = items.filter(o => {
    //  return o.dropdownGroup;
    //});
    this.currentItems = items.filter(o => {
      return true;// !o.dropdownGroup;
    });
  }
}
